module.exports = "<p>\n  location-routes works!\n</p>\n"